export type PublicationIdKeyParams = {
  publicationId: string;
};

export type PublicationFooterSettingsKeyParams = {
  entityId: number;
  publicationId: string;
};

export type MenuStoriesKeyParams = {
  menuId: string;
};

export type FolderHierarchyWithStoriesKeyParams = {
  publicationId: string;
  entityId: number;
};

// Params are kept as objects in the key so `queryClient.setQueryData` /
// `invalidateQueries` can target exact matches, and broad prefix matches
// (e.g. `[...all, 'navigationMenus']`) sweep every param variant.
export const setupOnlinePublicationQueryKeys = {
  all: ['setupOnlinePublication'] as const,
  navigationMenus: (params: PublicationIdKeyParams) =>
    [...setupOnlinePublicationQueryKeys.all, 'navigationMenus', params] as const,
  publicationBrandings: (params: PublicationIdKeyParams) =>
    [...setupOnlinePublicationQueryKeys.all, 'publicationBrandings', params] as const,
  tocSettings: (params: PublicationIdKeyParams) =>
    [...setupOnlinePublicationQueryKeys.all, 'tocSettings', params] as const,
  publicationFooterSettings: (params: PublicationFooterSettingsKeyParams) =>
    [...setupOnlinePublicationQueryKeys.all, 'publicationFooterSettings', params] as const,
  menuStories: (params: MenuStoriesKeyParams) =>
    [...setupOnlinePublicationQueryKeys.all, 'menuStories', params] as const,
  folderHierarchyWithStories: (params: FolderHierarchyWithStoriesKeyParams) =>
    [...setupOnlinePublicationQueryKeys.all, 'folderHierarchyWithStories', params] as const
} as const;
